import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import TextInput from "../../form/TextInput";
import DateTimeInput from "../../form/DateTimeInput";

class TaskForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="title"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Cím"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("reporter")}
                            name="reporter"
                            component="user"
                            storeType="remote"
                            objectValue={true}
                            valueKey={"name"}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.reporter}
                            label="Feladatot kiadja"
                        />
                    </div>
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("assignee")}
                            name="assignee"
                            component="user"
                            storeType="remote"
                            objectValue={true}
                            valueKey={"name"}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.assignee}
                            label="Feladatot megoldja"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("workgroup")}
                            name="workgroup"
                            component="group"
                            storeType="local"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.workgroup}
                            label="Csoport"
                        />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            {...this.props.getFieldProps("time_estimate")}
                            type="number"
                            name="time_estimate"
                            label="Feladatra szánt idő"
                            value={this.props.values.time_estimate}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            {...this.props.getFieldProps("time_spent")}
                            type="number"
                            name="time_spent"
                            label="Feladattal töltött idő"
                            value={this.props.values.time_spent}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            name="status"
                            optionname="task_manager_status"
                            objectValue={false}
                            storeType="local"
                            label="Státusz"
                            value={this.props.values.status}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <Select
                            name="type"
                            optionname="task_type"
                            objectValue={false}
                            storeType="local"
                            label="Feladat típusa"
                            value={this.props.values.type}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <Select
                            name="priority"
                            optionname="task_manager_priority"
                            objectValue={false}
                            storeType="local"
                            label="Prioritás"
                            value={this.props.values.priority}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            name="parent"
                            component="Task"
                            objectValue={false}
                            storeType="local"
                            label="Fő feladat"
                            value={this.props.values.parent}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("deadline")}
                            name="deadline"
                            value={this.props.values.deadline}
                            label="Határidő"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("finish_time")}
                            name="finish_time"
                            value={this.props.values.finish_time}
                            label="Feladat befejezésének az ideje"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>


                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("tags")}
                            name="tags"
                            component="tag"
                            isMulti={true}
                            labelKey="tagname"
                            storeType="remote"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            value={ this.props.values.tags }
                            label="Kulcsszavak"
                        />
                    </div>
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("assistant")}
                            name="assistant"
                            component="user"
                            isMulti={true}
                            storeType="remote"
                            objectValue={true}
                            valueKey={"name"}
                            saveChanges={this.props.setFieldValue}
                            value={ this.props.values.assistant }
                            label="Segítő"
                        />
                    </div>
                </div>


            </form>
        );
    }
}

export default createForm(TaskForm);
